const initialDynamicTableState = {
  fetching: false,
  fetched: true,
  updating: false,
  updated: false,
  error: null,
  organization: null,
  items: [],
  resultCount: 0,
  collaborators: {
    fetching: false,
    fetched: false,
    error: null,
    items: []
  },
  total: [],
  filter: {
    year: null,
    budgetStateConfig: [],
    budgetState: [],
    pageSize: 5,
    startPage: 0
  }
};
export const dynamicTableReducer = (
  state = initialDynamicTableState,
  action
) => {
  switch (action.type) {
    case "INIT_DYNAMIC_TABLE_DATA": {
      return initialDynamicTableState;
    }
    case "SET_DYNAMIC_TABLE_FILTER_YEAR": {
      return { ...state, filter: { ...state.filter, year: action.year } };
    }
    case "SET_PAGE_SIZE_STATE": {
      return {
        ...state,
        filter: { ...state.filter, pageSize: action.pageSize }
      };
    }
    case "SET_START_PAGE_STATE": {
      return {
        ...state,
        filter: { ...state.filter, startPage: action.startPage }
      };
    }
    case "SET_DYNAMIC_TABLE_DATA": {
      return {
        ...state,
        items: action.payload
      };
    }
    case "FETCH_DYNAMIC_TABLE_DATA_PENDING": {
      return {
        ...state,
        fetching: true,
        fetched: false,
        error: null,
        items: []
      };
    }
    case "FETCH_DYNAMIC_TABLE_DATA_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data["result"],
        total: data["total"],
        resultCount: data["count"],
        organization: action.payload.organization
      };
    }
    case "FETCH_DYNAMIC_TABLE_DATA_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        fetched: false,
        financialSheetData: [],
        error
      };
    }
    case "UPDATE_BUDGET_PARTS_PENDING": {
      return {
        ...state,
        updating: true,
        updated: false
      };
    }
    case "UPDATE_BUDGET_PARTS_FULFILLED": {
      return {
        ...state,
        updating: false,
        updated: true
      };
    }
    case "UPDATE_BUDGET_PARTS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        updated: false,
        error
      };
    }
    case "UPDATE_DYNAMIC_TABLE_DATA": {
      const { rowIndex, data } = action.payload;
      return {
        ...state,
        items: state.items.map(
          (row, index) => (index === rowIndex ? data : row)
        )
      };
    }
    case "SET_BUDGET_STATE": {
      return {
        ...state,
        filter: {
          ...state.filter,
          budgetState: action.selected
        }
      };
    }
    case "SET_BUDGET_STATE_CONFIG": {
      return {
        ...state,
        filter: {
          ...state.filter,
          budgetStateConfig: action.payload
        }
      };
    }
    case "FETCH_DYNAMIC_TABLE_COLLABORATORS_PENDING": {
      return {
        ...state,
        collaborators: {
          ...state.collaborators,
          fetching: true,
          fetched: false,
          error: null
        }
      };
    }
    case "FETCH_DYNAMIC_TABLE_COLLABORATORS_FULFILLED": {
      return {
        ...state,
        collaborators: {
          ...state.collaborators,
          fetching: false,
          fetched: true,
          error: null,
          items: action.payload
        }
      };
    }
    case "FETCH_DYNAMIC_TABLE_COLLABORATORS_REJECTED": {
      return {
        ...state,
        collaborators: {
          ...state.collaborators,
          fetching: false,
          fetched: false,
          error: {},
          items: []
        }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dynamic-table.js